export interface Belief {
  num: string;
  title: string;
  body: string;
}

export const BELIEFS: readonly Belief[] = [
  {
    num: '01',
    title: 'Discipline beats motivation, every single time.',
    body: "Motivation shows up when you don't need it and disappears the moment you do. Discipline is the thing that gets you to the desk on a Wednesday at 6am when you'd rather be doing anything else, and the longer you run on discipline instead of motivation, the more the work stops feeling like work, because the identity becomes \"I'm the person who does this,\" not \"I'm the person who wants to do this.\"",
  },
  {
    num: '02',
    title: "Time is currency when you don't have money.",
    body: "When you've got no capital, the only resource you have to invest is volume and time, which is the most fair and most brutal trade-off in business, because everyone gets the same 24 hours, and the only difference between someone a year ahead of you and someone a year behind you is how those hours got spent. That's why every system I build is structured around giving hours back.",
  },
  {
    num: '03',
    title: 'Proof of work earns the next level.',
    body: 'Most people try to talk their way into the next level. The faster path is to build something so visibly working that the next level comes to you, and the AI work I\u2019m doing now is exactly that, because I document it publicly, the systems speak for themselves, and people who need that work find me without me ever having to pitch them.',
  },
  {
    num: '04',
    title: 'Installed, not sold.',
    body: "The moment a system depends on me to keep running, it stops being yours. Every engagement is structured so the client owns the prompts, the workflows, the agents, and the knowledge base the day it goes live, and if I disappeared tomorrow, the whole thing would keep working. That's the line between a tool you bought and a system you own, and most of the AI industry right now is selling tools they pretend are systems.",
  },
  {
    num: '05',
    title: 'AI is a force multiplier under the right ethics.',
    body: "Used wrong, AI is a way to flood the world with low-effort noise. Used right, it's the closest thing we've ever had to a true compounding asset, every workflow you build today gets sharper the more you use it, every prompt you refine becomes a piece of permanent infrastructure, and every person you train to use it properly becomes more valuable to the business they're in.",
  },
];
